<template>
	<div class='online-details row'>
		<LoadingScreen :header="getText('TransactionLoadingHeader')" :message='loading_message' v-if='loading_message.length > 0'/>

		Test
	</div>
</template>

<style scoped lang="scss">
	.online-details{
		position: relative;
		min-height: 400px;
	}
</style>

<script>
import store from "@/store/";
import moment from 'moment';
import { mapGetters } from "vuex";

import { 
	GET_ORDER_DETAILS, 
	VALIDATE_PACKAGE, 
	LOAD_INVOICE_DATA_CACHE,
	PRELOAD_INVOICE_DATA 
} from "@/store/actions.type";
import {
	SET_INVOICE_DATA,
	SET_INVOICE_CACHE,
	SET_INVOICE_EDITABLE,
	SET_BILLING_INFO,
	SET_PAYMENT_METHOD,
	CLEAR_INVOICE_CACHE
} from "@/store/mutations.type";

// Language / Localization
import LanguageService from "@/common/language.service";

import LoadingScreen from "@/components/general/LoadingScreen";
import ErrorMessage from "@/components/messages/ErrorMessage";

export default {
	name: "Pay",
	components: {
		LoadingScreen,

		ErrorMessage
	},
	props: {
		details: {
		    type: String,
		    default: null
		}
    	},
	data(){
		return {
			loading_message: this.getText('TransactionLoadingText')
		};
	},
	beforeMount(){
		store.commit(CLEAR_INVOICE_CACHE);
		store.dispatch(LOAD_INVOICE_DATA_CACHE);
		if(this.details === null){
			//Check merchant's status (Do they allow open payments?)
			if(!this.merchant().RequireParams){
				// No variables or OrderId... route to Home
				this.$router.push({ name: 'Home' });
				return;
			} else {
				// Otherwise, merchant requires info we don't have. Fail!
				this.hard_error( this.getError('BadUrlData'));
			}
		}
		try{
		    var url_string = atob(this.details);
		    var data = JSON.parse(url_string);
		    this.load_params(data);
		}catch(error){
			console.log(error);
				this.hard_error( this.getError('BadUrlData'));
		    // @TODO -- In the future, Check if it is a orderId
		    // this.load_order(this.details);
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		getError(key){
			return LanguageService.getError(key);
       		},
		load_params(params){
			// If the amount is set, make sure it is a valid number
			if(params.amount !== undefined && isNaN(params.amount*1)){
				// failed amount validation
				this.hard_error( this.getError('BadUrlMissingAmount'));
				return;
			}

			var error = false;
			if(this.merchant().RequireParams){
				if(this.merchant().RequiredUrlParams.Country && !params.country){
					// failed country validation
					this.hard_error( this.getError('BadUrlMissingCountry'));
					error = true;
				}
				if(this.merchant().RequiredUrlParams.Amount && !params.amount){
					// failed amount validation
					this.hard_error( this.getError('BadUrlMissingAmount'));
					error = true;
				}
				if(this.merchant().RequiredUrlParams.Invoice && !params.invoice){
					// failed invoice validation
					this.hard_error( this.getError('BadUrlMissingInvoice'));
					error = true;
				}
			}
			// Check for expiry
			if(params.expires !== undefined && params.expires.length > 0){
				//Validate expiry
				var expires_on = moment.utc(params.expires);
				var current_time = moment.utc();

				if(expires_on < current_time){
					this.soft_error( this.getError('InvoiceLinkHasExpired'));
					error = true;
				}
			}
			// We caught an error, don't want to store the data
			if(error) return;
			// Send parsed data off to the data-store
			store.dispatch(PRELOAD_INVOICE_DATA, params).then(() => {
				this.$router.push({ name: 'Home' });
			});     
		},
		load_order: function(order_id){
			// Load order data, then set store and reload page
			store.dispatch(GET_ORDER_DETAILS, order_id).then(data => {

			//console.log(data);

			// Make sure we have proper items
			if(data.Items === undefined) throw "Error";
			var invoice_item = data.Items.filter(x => x.Sku == "Invoice");
			if(invoice_item.length < 1) throw "Error";

			// Grab merchant amount
			var invoice_amount = invoice_item[0].MerchantPrice;

			// STEP 1: Set our invoice data
			store.commit(SET_INVOICE_DATA, {
				id: data.ReferenceId,
				amount: invoice_amount,
				payment_country: data.Consumer.Country
			});

			// Optional National Identifier
			if(data.Consumer.NationalIdentifier === undefined){
				data.Consumer.NationalIdentifier = "";
			}

			// Optional Birthdate
			if(data.Consumer.BirthDate === undefined){
				data.Consumer.BirthDate = "";
			}

			// STEP 2: Set our Billing data
			store.commit(SET_BILLING_INFO, {
				Name: data.Consumer.Name || '',
				Email: data.Consumer.Email || '',
				Address: data.Consumer.Address || '',
				City: data.Consumer.City || '',
				Region: data.Consumer.Region || '',
				Country: data.Consumer.Country || '',
				PostalCode: data.Consumer.PostalCode || '',
				Phone: data.Consumer.Phone || '',
				NationalIdentifier: data.Consumer.NationalIdentifier || '',
				BirthDate: data.Consumer.BirthDate || ''
			});

			// STEP 3: Set our payment data
			store.commit(SET_PAYMENT_METHOD, {
				Class: data.Payment.Class || '',
				Id: data.Payment.Method || '',
				Name: ""
			});

			// Now route back to primary view
			this.$router.push({ name: 'Home' });

			}).catch(error => {
				this.loading_error(this.getError('OrderNotFound'));
				return;
			});
		},
		loading_error: function(message){
			// An error occured, route to home with message
			this.$router.push({ name: 'Home', params: { error: message }});
		},
		hard_error: function(message){
			// An error occured, route to home with message
			this.$router.push({ name: 'Error', params: { error: message }});
		},
		soft_error: function(message){
			// An error occured, route to home with message
			this.$router.push({ name: 'Warning', params: { error: message }});
		},
		...mapGetters(["merchant"])
	}
}
</script>
